import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  reset() {
    window.jQuery("#new_message").removeClass("search loading");
    window.jQuery("#new_message input[disabled]").attr("disabled", false);
    window.CKEDITOR.instances.editor1.setData("");
  }
}
